<span [matTooltip]="state.tooltipDate" [matTooltipDisabled]="!showTooltip">{{ state.timeAgo }}</span>
